var OdbIdentityProvider = require('./odbIdentityProvider');

var ModeratorAccessController = require('./moderatorAccessController');

var ThreadAccessController = require('./threadAccessController');

var LegacyIPFS3BoxAccessController = require('./legacyIpfs3boxAccessController');

module.exports = {
  OdbIdentityProvider: OdbIdentityProvider,
  ModeratorAccessController: ModeratorAccessController,
  ThreadAccessController: ThreadAccessController,
  LegacyIPFS3BoxAccessController: LegacyIPFS3BoxAccessController
};